function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import SparkMD5 from 'spark-md5';
import stringify from 'fast-json-stable-stringify';
import store from '../reducers/storeRegistration';
import serverNativeBehaviorEvaluator from './serverNativeBehaviorEvaluator';
import { actionRegistrar } from '../actions/entityActionRegistrar';

// Cache key prefix for queryEntityBehavior entries
const CACHE_KEY_PREFIX = 'queryEntityBehavior_';

/**
 * Generate a deterministic cache key from source parameters
 * Uses MD5 hash with fast-stable-stringify for consistent ordering
 * Matches server-side logic: use source object as-is (already evaluated)
 */
const generateCacheKey = source => {
  // Handle null/undefined source values
  const safeSource = source !== null && source !== void 0 ? source : {};

  // Remove 'type' field to match server-side normalization
  const normalizedSource = _objectSpread({}, safeSource);
  delete normalizedSource.type;

  // Use fast-stable-stringify to ensure consistent property ordering
  const sourceString = stringify(normalizedSource);
  const hash = SparkMD5.hash(sourceString);
  return `${CACHE_KEY_PREFIX}${hash}`;
};

/**
 * Manage a web cache of queryEntityBehavior results
 * This web native behavior wraps the server queryEntityBehavior with client-side caching
 * Cache is automatically cleared when forms are unloaded via clearEditorCache
 * @param {Object} entity - The entity object
 * @param {string} entityName - The name of the entity
 * @param {Object} source - The query source object to be passed to the server evaluator
 *  and also used to generate a cache key.
 * @param {Object} content - The content object
 * @param {string} parentContentPath - The parent content path
 * @param {Object} transientContext - The transient context object
 * @param {Object} nativeFunctions - The native functions object
 * @param {Object} sourceEvaluator - The source evaluator object
 * @returns {*} The query result from the cache or server
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const cacheKey = generateCacheKey(source);
  const state = store.getState();
  const {
    editorCache = {}
  } = state[entityName] || {};
  const cacheEntry = editorCache[cacheKey];

  // Check cache first
  if (cacheEntry) {
    return cacheEntry;
  }
  const result = await serverNativeBehaviorEvaluator.evaluate(entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);

  // Store in cache
  const entityActions = actionRegistrar(entityName);
  store.dispatch(entityActions.setEditorCacheValue(cacheKey, result));
  return result;
};
export default {
  evaluate
};